import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { NgIf, NgFor, NgTemplateOutlet } from '@angular/common';
import { DashboardCard } from 'src/app/interfaces/strapi';
import { CmsLinkComponent } from '../cms-link/cms-link.component';
import HeaderComponent from '../header/header.component';

@Component({
    selector: 'app-vertical-carousel',
    templateUrl: './vertical-carousel.component.html',
    styleUrls: ['./vertical-carousel.component.scss'],
    imports: [
        NgIf,
        NgFor,
        NgTemplateOutlet,
        CmsLinkComponent,
        HeaderComponent,
    ],
})
export class VerticalCarouselComponent implements AfterViewInit, OnDestroy {
  @Input() public carousel: DashboardCard[] = [];

  // @ts-ignore
  @ContentChild(TemplateRef) templateRef: TemplateRef<any> | null;

  @ViewChild('sliderRef') private readonly sliderRef!: ElementRef<HTMLElement>;

  public innerWidth: number | undefined;

  @HostListener('window:resize')
  public onResize() {
    this.innerWidth = window.innerWidth;
  }

  @HostListener('window:resize')
  onScreenChange() {
    this.isMobile = window.innerWidth < 992;
  }

  public isMobile: boolean = window.innerWidth < 992;

  public currentSlideIndex = 0;

  public slider: KeenSliderInstance | null = null;

  ngAfterViewInit() {
    if (this.sliderRef) {
      this.slider = new KeenSlider(this.sliderRef.nativeElement, {
        loop: false,
        mode: 'free-snap',
        slides: {
          perView: 'auto',
          spacing: 8,
        },

        breakpoints: {
          '(min-width: 992px)': {
            loop: this.showArrows,
            slides: {
              perView: 3,
              spacing: 15,
            },
          },
        },
        slideChanged: (s) => {
          this.currentSlideIndex = s.track.details.abs;
        },
      });
    }
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
  }

  public getArticleSnippet(excerpt: string): string {
    return `${excerpt.slice(0, 60)}...`;
  }

  public get showArrows(): boolean {
    return this.carousel && this.carousel.length > 3;
  }

  public doPrev(): void {
    this.slider?.prev();
  }

  public doNext(): void {
    this.slider?.next();
  }
}
